import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface FooterProps {
  className?: string;
}

export const Footer: React.FC<FooterProps> = ({ className }) => {
  return (
    <footer className={cn('bg-white border-t border-gray-200', className)}>
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="flex flex-col md:flex-row md:justify-between md:items-start gap-12">
          {/* Left: Logo and description */}
          <div className="flex-1 min-w-[240px]">
            <div className="text-2xl font-extrabold text-gray-900 mb-2">AskiiMall</div>
            <div className="text-gray-500 text-base max-w-xs mb-8 md:mb-0">
              The central marketplace for discovering and integrating powerful, context-aware AI services.
            </div>
          </div>
          {/* Right: Links */}
          <div className="flex flex-row gap-16">
            <div>
              <div className="text-xs font-semibold text-gray-500 tracking-widest uppercase mb-4">Company</div>
              <ul className="space-y-2">
                <li>
                  <Link to="/about" className="text-gray-700 hover:text-blue-600 text-base transition-colors">About</Link>
                </li>
                <li>
                  <Link to="/contact" className="text-gray-700 hover:text-blue-600 text-base transition-colors">Contact</Link>
                </li>
              </ul>
            </div>
            <div>
              <div className="text-xs font-semibold text-gray-500 tracking-widest uppercase mb-4">Legal</div>
              <ul className="space-y-2">
                <li>
                  <Link to="/privacy" className="text-gray-700 hover:text-blue-600 text-base transition-colors">Privacy Policy</Link>
                </li>
                <li>
                  <Link to="/terms" className="text-gray-700 hover:text-blue-600 text-base transition-colors">Terms of Service</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-200 mt-12 pt-8 flex flex-col md:flex-row md:justify-between md:items-center gap-4">
          <div className="text-gray-400 text-sm">© 2025 AskiiMall, Inc. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
};
